<template>
  <div class="vehicleApplyPage" v-if="!this.showLoad">
    <div class="applyFrom">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.licensePlateNumber"
          label="车牌号："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.brandName"
          label="品牌："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.modelSpecifications"
          label="型号规格："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.unitCost"
          label="费用（元/公里）："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.currentMileage"
          label="当前里程（公里）："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="baseData.seatingCapacity"
          label="座位数（个）："
          :required="editType"
          :readonly="!editType"
          input-align="right"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone enableBox">
        <van-cell center title="状态：" class="ggInput">
          <template #right-icon>
            <van-switch
              v-model="baseData.enable"
              size="24"
              :readonly="!editType"
              inactive-color="#f6f6f6"
            />
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="baseNone summaryBox">
        <van-field
          v-model="baseData.remarks"
          label="备注："
          rows="1"
          autosize
          type="textarea"
          input-align="right"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
        />
      </van-cell-group>
      <div class="btnBox" v-if="editType && this.commonType == 'add'">
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >提交</van-button
        >
      </div>
      <div
        class="btnBox editBtnbox clearfix"
        v-if="editType && this.commonType == 'edit'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delCarMsg"
              class="btn fl"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn fr"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "vehicleManage", //车辆管理    新增/编辑/查看
  data() {
    return {
      carId: "",
      loading: false,
      editType: false, //当前编辑状态
      baseData: {
        licensePlateNumber: "", //车牌号
        brandName: "", //品牌
        currentMileage: "", //当前里程数
        enable: true, //是否启用
        modelSpecifications: "", //型号规格
        remarks: "", //备注
        seatingCapacity: "", //座位数
        unitCost: "", //每公里费用
      },
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(), //手机类型
    };
  },
  created() {
    document.title = "车辆基本信息";
  },
  mounted() {
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.carId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    window.editPage = this.editPage; //调用编辑
    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      if (this.commonType == "add") {
        this.setShowLoad(false);
        this.editType = true;
      } else {
        this.getPageMain();
      }
    },
    getPageMain() {
      //查看或编辑
      let _this = this;
      _this.setShowLoad(false);
      _this.$api.material.vehicleManage.info(_this.carId).then((res) => {
        if (res.code == "1" && res.data != null) {
          _this.baseData = res.data;
          if (_this.baseData.remarks == null) {
            _this.$set(_this.baseData, "remarks", "");
          }
          if (_this.mode == "edit") {
            if (_this.clientType == "android") {
              window.android.getInfo(102);
            } else {
              window.webkit.messageHandlers.showEdit.postMessage(null);
            }
          }
        } else {
          if (res.data == null) {
            let text = "该车辆已删除";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
        }
      });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    checkInput() {
      if (
        this.baseData.licensePlateNumber == "" ||
        this.baseData.brandName == "" ||
        this.baseData.currentMileage == "" ||
        this.baseData.modelSpecifications == "" ||
        this.baseData.seatingCapacity == "" ||
        this.baseData.unitCost == ""
      ) {
        this.$toast("带星号为必填，不能为空");
      } else {
        this.saveCarMsg();
      }
    },
    saveCarMsg() {
      //保存车辆信息
      let _this = this;
      _this.btnLoading = true;
      _this.$api.material.vehicleManage
        .save(_this.commonType, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            _this.$toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              message: _this.mode == "add" ? "添加成功" : "编辑成功",
            });
            const timer = setInterval(() => {
              clearInterval(timer);
              _this.$toast.clear();
              if (_this.clientType == "android") {
                window.android.getInfo(103);
              } else {
                window.webkit.messageHandlers.closePage.postMessage("1");
              }
            }, 1000);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.btnLoading = false;
        });
    },
    //删除车辆信息
    delCarMsg() {
      const _this = this;
      _this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除当前车辆吗？",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.vehicleManage
            .deleteVehicle(_this.carId)
            .then((res) => {
              if (res.code == "1") {
                _this.$toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: "删除成功",
                });
                const timer = setInterval(() => {
                  clearInterval(timer);
                  _this.$toast.clear();
                  if (_this.clientType == "android") {
                    window.android.getInfo(103);
                  } else {
                    window.webkit.messageHandlers.closePage.postMessage("1");
                  }
                }, 1000);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            });
        })
        .catch(() => {
          _this.btnLoading = false;
        });
    },
  },
  computed: {
    ...mapState(["showLoad"]),
  },
};
</script>
<style lang="less">
.vehicleApplyPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .applyFrom {
    height: 100%;
    overflow-y: scroll;
  }
  .baseNone::after {
    content: none;
  }
  .baseSalary {
    box-sizing: border-box;

    height: 45px;
    .baseNone {
      .van-field__body {
        .van-field__control {
          text-align: right;
          color: #969799;
        }
      }
    }
    .ggInput {
      height: 45px;
      border-bottom: 1px solid #f6f6f6;
    }
    .van-cell:not(:last-child)::after {
      content: none;
    }
  }
  .summaryBox {
    min-height: 45px;
    margin-bottom: 2px;
    border-bottom: 1px solid #f6f6f6;

    .van-cell__value {
      .van-field__control {
        color: #969799;
      }
    }
  }
  .enableBox {
    .van-cell {
      border-bottom: 1px solid #f6f6f6;
    }
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .dwBox .van-cell .van-cell__value {
    padding-right: 0;
  }
  h4 {
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #2581d6;
    font-size: 15px;
    z-index: 10;
    background-color: #fff;
  }
  h4:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 30px;
    background: #2581d6;
    top: 7px;
    left: 10px;
    bottom: 5px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 45px;
    position: fixed;
    left: 0;
    bottom: 14px;
    .btn {
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
}
</style>